import { ReactNode, useContext } from 'react';

import { useMediaQuery } from '@mui/material';
import { createPortal } from 'react-dom';

import { PageFooterContext } from './context';
import { FooterBar, FooterContent, FooterSlot } from './index.styles';

export interface PageFooterProps {
  children: ReactNode;
  /** The page's own measure, so the bar's contents line up with the page above it. */
  maxWidth?: number;
}

/** A window this short, a phone on its side or a page zoomed in, keeps its height for the page. */
const SHORT_WINDOW = '34em';

/**
 * A bar along the foot of the content panel, outside its scroll so it stays in
 * view however far the page is scrolled: a form's actions, a step's Next.
 * Without a panel to hold it, or in a short window, it draws where it is placed.
 */
const PageFooter = ({ children, maxWidth }: PageFooterProps) => {
  const slot = useContext(PageFooterContext);
  const short = useMediaQuery(`(max-height: ${SHORT_WINDOW})`);
  const dock = short ? null : slot;
  const bar = (
    <FooterBar $docked={!!dock}>
      <FooterContent $maxWidth={maxWidth}>{children}</FooterContent>
    </FooterBar>
  );

  return dock ? createPortal(bar, dock) : bar;
};

export { FooterSlot as PageFooterSlot };

export default PageFooter;
